var exports = {
  "vK": "x31de4314--e01a0c--banner",
  "Sl": "x31de4314--e01a0c--image",
  "Qs": "x31de4314--e01a0c--content",
  "_A": "x31de4314--e01a0c--tags",
  "Et": "x31de4314--e01a0c--tags-skeleton",
  "Qq": "x31de4314--e01a0c--text",
  "XI": "x31de4314--e01a0c--action",
  "bu": "x31de4314--e01a0c--compact-banner",
};

module.exports = exports;
